import script from "./PreguntasRespuestas.vue?vue&type=script&setup=true&lang=js"
export * from "./PreguntasRespuestas.vue?vue&type=script&setup=true&lang=js"

import "./PreguntasRespuestas.vue?vue&type=style&index=0&id=caf88d62&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-caf88d62"]])

export default __exports__